import { RESET_WIDGET } from '../../actions/common';
import {
  SET_DEPOSIT_CHECKOUT_STATE,
  SET_PAYMENT_CHECKOUT_STATE,
  SET_PAYMENT_AMOUNT,
  SET_USE_BALANCE_FUNDS,
  SET_TRANSACTION_ID,
} from '../../actions/checkout';
import { TReduxActions } from '../../types/actions';
import { ICheckoutState } from '../../types/redux/checkout';

const defaultState: ICheckoutState = {
  isUseBalanceFundsVisible: false,
  isUseBalanceFunds: false,
  price: 0,
  balance: 0,
  totalAmount: 0,
  paymentAmount: 0,
  productType: null,
  paymentInitSource: null,
  transactionId: undefined,
  packageId: undefined,
};

export const checkoutReducer = (state: ICheckoutState = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case SET_PAYMENT_CHECKOUT_STATE:
    case SET_DEPOSIT_CHECKOUT_STATE:
      return {
        ...state,
        ...action.payload,
      };

    case SET_PAYMENT_AMOUNT:
      return {
        ...state,
        paymentAmount: action.payload,
      };

    case SET_USE_BALANCE_FUNDS: {
      const isUseBalanceFunds = action.payload;
      const paymentAmount = isUseBalanceFunds ? state.totalAmount : state.price;

      return {
        ...state,
        isUseBalanceFunds,
        paymentAmount,
      };
    }

    case SET_TRANSACTION_ID: {
      return {
        ...state,
        transactionId: action.payload,
      };
    }

    case RESET_WIDGET:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
};
